import React, { Component } from 'react'

// Styles
import './index.scss'

// Components
import Form from './Form'

class GetQuote extends Component {
  render = () => {
    return (
      <div className="get-quote-parent">
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>Get a Quote</h2>
          </div>
        </div>

        <div className="container">
          <div className="form-parent">
            <div className="border-content first">
              <div className="border-content second">
                <div className="border-content third">
                  <p style={{ paddingTop: '0', paddingBottom: '0', marginBottom: '1rem' }}>Send us a request by completing the below and we’ll get back to you!</p>
                  <Form />
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

    )
  }
}

export default GetQuote